import { app } from '../../../../app';

app.service('AccountConfigModal', modal);

/** @ngInject */
function modal($uibModal) {

    return (applicationId, accountId) => {

        return $uibModal.open({
            component: 'accountConfig',
            resolve: {
                applicationId: () => applicationId,
                accountId: () => accountId,
                config
            }
        }).result;

        /** @ngInject */
        function config(AccountConfigService) {
            return AccountConfigService.get(applicationId, accountId);
        }
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/user/applications/account-config/account-config.modal.js